import { heroBackgroundStyle } from '../utils/imageAssets';
import { heroImages } from '../assets/menuImages';

function PageHero({ tag, title, subtitle }) {
  return (
    <section
      className="page-hero"
      style={heroBackgroundStyle(heroImages.background)}
    >
      <div className="page-hero-inner">
        {tag && <p className="page-hero-tag">{tag}</p>}
        <h1 className="page-hero-title">{title}</h1>
        {subtitle && <p className="page-hero-subtitle">{subtitle}</p>}
      </div>
    </section>
  );
}

export default PageHero;
